import Router from '@app/router';
import { prefetch } from '@app/router/prefetcher';
import { EventTracking, EventType } from '@app/tracking';
import Helpers from '@app/global/helpers';
export default {
    mounted(el) {
        // Replace internal native a-link with Vue router-links
        el.addEventListener('click', event => handleLinkClicks(event));
        // Observe internal native links for prefetching
        Array.from(el.querySelectorAll('a[href]'))
            .filter(a => !Helpers.isExternalLink(a.href))
            .forEach(a => {
            a.addEventListener('mouseover', e => {
                prefetch(a.href);
            }, { once: true });
        });
        // Scale down inline images
        const images = Array.from(el.querySelectorAll('img'));
        images.forEach(image => transformImage(image));
    }
};
function transformImage(image) {
    image.setAttribute('loading', 'lazy');
    image.classList.add('img-fluid', 'w-100');
}
function handleLinkClicks($event) {
    const { target } = $event;
    // handle only links that occur inside the component and do not reference external resources
    if (target && target.matches("a:not([href^='http'])") && target.href) {
        // some sanity checks taken from vue-router:
        // https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L106
        const { altKey, ctrlKey, metaKey, shiftKey, button, defaultPrevented } = $event;
        // don't handle with control keys
        if (metaKey || altKey || ctrlKey || shiftKey)
            return;
        // don't handle when preventDefault called
        if (defaultPrevented)
            return;
        // don't handle right clicks
        if (button !== undefined && button !== 0)
            return;
        // don't handle if `target="_blank"`
        if (target && target.getAttribute) {
            const linkTarget = target.getAttribute('target');
            if (/\b_blank\b/i.test(linkTarget))
                return;
        }
        const url = new URL(target.href);
        const to = url.pathname;
        // don't handle media download links
        if (to.substring(0, 7) == '/media/')
            return;
        // don't handle mailto: and tel: links
        if (to.substring(0, 7) == 'mailto:')
            return;
        if (to.substring(0, 4) == 'tel:')
            return;
        // don't handle same page links/anchors
        if (window.location.pathname !== to && $event.preventDefault) {
            $event.preventDefault();
            Router.push(to);
        }
    }
    else if (target && target.matches("a") && target.href) {
        $event.preventDefault();
        const domain = window.location.protocol + '//' + window.location.hostname;
        if (target.href.indexOf(domain) !== -1) {
            // Internal absolute
            Router.push(target.href.replace(domain, ''));
        }
        else {
            // Real outbound link
            EventTracking.dispatch(EventType.Track, {
                category: 'Outbound',
                action: 'click',
                label: target.href
            });
            window.open(target.href, target.target || '_self');
        }
    }
}
